import { PolicyTermType } from '../../types/index';
import { getPolicyTerms } from "actions/Utilities/Policy";
import { useQuery } from "react-query";

export default function usePolicyTerm() {
  //Fetching Term Details
  const {data, isFetching} = useQuery("GetTerms", getPolicyTerms, {
    refetchOnWindowFocus: false,
  });

  return {data: data as PolicyTermType[], isFetching};
}
